import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableBulkRecommendedRatesOnSuperSelect = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableBulkRecommendedRatesOnSuperSelect);
};
